import { BiLayer } from 'react-icons/bi'

import { Flex, HStack, Text, VStack } from '@chakra-ui/react'

export const FloorsPanelHeader = () => {
  return (
    <Flex
      align='center'
      borderBottom='1px solid rgba(9, 30, 66, 0.14)'
      direction='column'
      padding='30px'
    >
      <VStack alignItems='start' spacing='10px' w='full'>
        <HStack>
          <BiLayer color='#44546F' size={26} />
          <Text
            color='#1F2023'
            fontSize='20px'
            fontWeight={700}
            lineHeight='30px'
          >
            Floors
          </Text>
        </HStack>
        <Text
          color='#1F2023'
          fontSize='12px'
          fontWeight={300}
          lineHeight='18px'
          pb='5px'
        >
          All floors for this facility are displayed here. You can edit floor
          details.
        </Text>
      </VStack>
    </Flex>
  )
}
